import styled from 'styled-components'
import { DescriptionGlobal } from '../../Compliance/styles'

export const Wrap = styled('div')`
  width: 1117px;
  margin: 0 auto;
  padding-top: 100px;
  padding-bottom: 100px;
  @media (max-width: 1200px) {
    width: 100%;
    padding: 50px 15px 50px 15px;
  }
`

export const Title = styled('div')`
  font-family: var(--bold);
  font-size: 32px;
  color: var(--text);
  @media (max-width: 1200px) {
    font-size: 24px;
  }
`
export const Description = styled(DescriptionGlobal)`
  font-size: 24px;
  line-height: 28px;
  margin-top: 15px;
  span {
    font-family: var(--semiBold);
  }
  @media (max-width: 1200px) {
    font-size: 18px;
    margin-top: 5px;
  }
`

export const Grid = styled('div')`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  margin-top: 70px;
  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`
